require('./../scss/style.scss');
require('swiper/css');
require('swiper/css/pagination');
require('swiper/css/navigation');

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./vendor/', true, /\.js$/));
requireAll(require.context('./project/', true, /\.js$/));
